import { render, staticRenderFns } from "./SeatIcon.vue?vue&type=template&id=7977096c"
import script from "./SeatIcon.vue?vue&type=script&lang=js"
export * from "./SeatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports